export const selectGameBalance = (state) => state.game.balance

export const selectGameUserStatus = (state) => state.game.userStatus

export const selectGameIpBan = (state) => state.game.ipBan
